module.exports = __webpack_public_path__ + "img/Download_Filled_24px_Icon-light.48ff20d8.svg";